import React from 'react'
import {Radar} from 'react-chartjs-2'
import PropTypes from 'prop-types';
import {objectWithoutProperties} from '../../../../utils/utils'


//================ Property Value Type =====================
const propsType={
    children:PropTypes.node,
};

//================ Default Property Value =====================
const defaultProps={
    
};

const RadarChart=(props)=>{

    const _props=props,
            children=_props.children,
            className=_props.className,
            attribute=objectWithoutProperties(props,'children');
        
    return (
        React.createElement(
            Radar,
            {className:className,attribute},
            children
        )
    )
}

RadarChart.propTypes=propsType;
RadarChart.defaultProps=defaultProps;

export default RadarChart;